/**
 * Round 18 G29 -- teach once.
 *
 * An explainer showed at every meeting until its reader pressed "Got
 * it", and most readers never do: the IBS and cascade explainers, the
 * positions paragraph and the admission explainer repeated on every
 * visit. The surface that first shows a term keeps showing it (the
 * reader is still reading); the next meeting in this visit is quiet.
 *
 * Round 19 H49 -- showing is not meeting. G29 saved a term as met the
 * moment it was drawn, so a read-only visit wrote to the person's
 * preferences: a load read with no button pressed left nine seats with
 * their sentences already gone at their first hour. A term is now saved
 * when the person acts on it -- "Got it", or opening its fuller
 * definition -- and a drawn one is only quiet for the rest of the visit.
 */
import { api } from "shared/api/client";

const shownThisVisit = new Set<string>();

/** Was this term shown by another surface earlier in this visit? */
export function shownBefore(key: string): boolean {
  return shownThisVisit.has(key);
}

/** Record that this term has been shown: quiet for the rest of the
 *  visit. Nothing is saved (round 19 H49). */
export function recordShown(key: string): void {
  shownThisVisit.add(key);
}

/** The person acted on the term (opened its fuller definition): met,
 *  from now on, saved where "Got it" saves it. Fire and forget: a
 *  failure leaves the term to be taught once more, never a broken page. */
export function recordActedOn(key: string): void {
  shownThisVisit.add(key);
  void api.patch("/v1/me/preferences", { met_term: key }).catch(() => undefined);
}

/** Tests only: each test starts with nothing shown. */
export function resetTeachOnce(): void {
  shownThisVisit.clear();
}
